import { render, staticRenderFns } from "./NewAd.vue?vue&type=template&id=2c8b8140&scoped=true&lang=html&"
import script from "./NewAd.vue?vue&type=script&lang=js&"
export * from "./NewAd.vue?vue&type=script&lang=js&"
import style0 from "./NewAd.vue?vue&type=style&index=0&id=2c8b8140&lang=scss&scoped=true&"
import style1 from "./NewAd.vue?vue&type=style&index=1&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b8140",
  null
  
)

export default component.exports